import css from 'styled-jsx/css';

const logoSpritePositions = css`
  .logo--Acura {
    background-position: -4px 1px;
  }
  .logo--Alfa.Romeo {
    background-position: -4px -48px;
  }
  .logo--AM.General {
    background-position: -4px -96px;
  }
  .logo--Aston.Martin {
    background-position: -4px -144px;
  }
  .logo--Audi {
    background-position: -4px -191px;
  }
  .logo--BMW {
    background-position: -4px -238px;
  }
  .logo--Bentley {
    background-position: -4px -287px;
  }
  .logo--Buick {
    background-position: -4px -336px;
  }
  .logo--Cadillac {
    background-position: -4px -384px;
  }
  .logo--Chevrolet {
    background-position: -4px -432px;
  }
  .logo--Chrysler {
    background-position: -4px -480px;
  }
  .logo--Daewoo {
    background-position: -4px -530px;
  }
  .logo--Dodge {
    background-position: -4px -578px;
  }
  .logo--Eagle {
    background-position: -4px -624px;
  }
  .logo--Ferrari {
    background-position: -4px -672px;
  }
  .logo--FIAT {
    background-position: -4px -720px;
  }
  .logo--Fisker {
    background-position: -4px -772px;
  }
  .logo--Ford {
    background-position: -4px -820px;
  }
  .logo--GMC {
    background-position: -4px -867px;
  }
  .logo--Geo {
    background-position: -4px -916px;
  }
  .logo--Honda {
    background-position: -4px -964px;
  }
  .logo--HUMMER {
    background-position: -4px -1012px;
  }
  .logo--Hyundai {
    background-position: -4px -1060px;
  }
  .logo--Infiniti {
    background-position: -4px -1108px;
  }
  .logo--Isuzu {
    background-position: -4px -1156px;
  }
  .logo--Jaguar {
    background-position: -4px -1204px;
  }
  .logo--Jeep {
    background-position: -4px -1252px;
  }
  .logo--Kia {
    background-position: -4px -1298px;
  }
  .logo--Lamborghini {
    background-position: -4px -1349px;
  }
  .logo--Land.Rover {
    background-position: -4px -1397px;
  }
  .logo--Lexus {
    background-position: -4px -1443px;
  }
  .logo--Lincoln {
    background-position: -4px -1491px;
  }
  .logo--Lotus {
    background-position: -4px -1541px;
  }
  .logo--MINI {
    background-position: -4px -1589px;
  }
  .logo--Maserati {
    background-position: -4px -1637px;
  }
  .logo--Maybach {
    background-position: -4px -1685px;
  }
  .logo--Mazda {
    background-position: -4px -1732px;
  }
  .logo--Mercedes-Benz {
    background-position: -4px -1783px;
  }
  .logo--Mercury {
    background-position: -4px -1831px;
  }
  .logo--Mitsubishi {
    background-position: -4px -1879px;
  }
  .logo--Nissan {
    background-position: -4px -1927px;
  }
  .logo--Oldsmobile {
    background-position: -4px -1971px;
  }
  .logo--Panoz {
    background-position: -4px -2020px;
  }
  .logo--Plymouth {
    background-position: -4px -2071px;
  }
  .logo--Pontiac {
    background-position: -4px -2117px;
  }
  .logo--Porsche {
    background-position: -4px -2167px;
  }
  .logo--Ram {
    background-position: -4px -2213px;
  }
  .logo--Rolls-Royce {
    background-position: -4px -2262px;
  }
  .logo--Saab {
    background-position: -4px -2310px;
  }
  .logo--Saturn {
    background-position: -4px -2359px;
  }
  .logo--Scion {
    background-position: -4px -2407px;
  }
  .logo--Smart {
    background-position: -4px -2453px;
  }
  .logo--Sterling {
    background-position: -4px -2504px;
  }
  .logo--Subaru {
    background-position: -4px -2552px;
  }
  .logo--Suzuki {
    background-position: -4px -2601px;
  }
  .logo--Tesla {
    background-position: -4px -2649px;
  }
  .logo--Toyota {
    background-position: -4px -2695px;
  }
  .logo--Volkswagen {
    background-position: -4px -2743px;
  }
  .logo--Volvo {
    background-position: -4px -2795px;
  }
  .logo--Bugatti {
    background-position: -4px -2843px;
  }
  .logo--Datsun {
    background-position: -4px -2891px;
  }
  .logo--McLaren {
    background-position: -4px -2939px;
  }
  .logo--SRT {
    background-position: -4px -2986px;
  }
  .logo--Sterling.Trucks {
    background-position: -4px -3034px;
  }
  .logo--American.Motors {
    background-position: -4px -3082px;
  }
  .logo--Genesis {
    background-position: -4px -3129px;
  }
  .logo--DeLorean {
    background-position: -4px -3178px;
  }
  .logo--Karma {
    background-position: -4px -3226px;
  }
  .logo--Lucid {
    background-position: -4px -3258px;
  }
  .logo--Rivian {
    background-position: -4px -3300px;
  }
  .logo--Pininfarina {
    background-position: -4px -3358px;
  }
  .logo--Polestar {
    background-position: -4px -3414px;
  }
  .logo--VinFast {
    background-position: -4px -3470px;
  }
  .logo--Wagoneer {
    background-position: -4px -3526px;
  }
`;
export default logoSpritePositions;
